import {createSlice} from '@reduxjs/toolkit'

const initialHotelBrandState = {
  totalCount: 0,
  hotel_brands: null,
  hotel_brand: undefined,
  hotel_brands_dropdown: [],
}

export const HotelBrandSlices = createSlice({
  name: 'hotel_brands',
  initialState: initialHotelBrandState,
  reducers: {
    hotel_brand: (state, action) => {
      state.hotel_brand = action.payload.hotel_brand
    },
    hotel_brands: (state, action) => {
      state.hotel_brands = action.payload.hotel_brands
      state.totalCount = action.payload.total_count
    },
    hotel_brands_dropdown: (state, action) => {
      state.hotel_brands_dropdown = action.payload.hotel_brands
    },
  },
})
